/**
 * 初始化基础组件，将window挂载进来
 */
const HYCOMPONENTS = [];
const context = require.context('./', true, /index.js$/);
context.keys().forEach((key) => {
  const comp = context(key);
  comp.default && HYCOMPONENTS.push(comp);
});

export default {
  install(Vue) {
    HYCOMPONENTS.forEach((module) => {
      Object.values(module).forEach((comp) => {
        comp.name && Vue.component(comp.name, comp);
      });
    });
  },
};
